export default function Gallery() {
  const products = [
    {
      title: "포장재용 목형",
      description: "다양한 포장재 생산을 위한 정밀 목형",
      image: "https://public.readdy.ai/ai/img_res/0d06435f3a3709ee5b022944514c366b.jpg"
    },
    {
      title: "주물용 목형",
      description: "금속 주조를 위한 고정밀 목형",
      image: "https://readdy.ai/api/search-image?query=industrial%20wooden%20casting%20pattern%20mold%20for%20metal%20foundry%20work%20with%20precise%20geometric%20shapes%20and%20professional%20finish%20on%20clean%20white%20background%20showing%20traditional%20craftsmanship&width=600&height=400&seq=woodmold-gallery-002&orientation=landscape"
    },
    {
      title: "특수 제품용 목형",
      description: "맞춤형 특수 제품 생산용 목형",
      image: "https://readdy.ai/api/search-image?query=custom%20specialty%20wooden%20mold%20pattern%20with%20intricate%20details%20and%20complex%20shapes%20for%20specialized%20product%20manufacturing%20on%20clean%20white%20background%20professional%20craftsmanship&width=600&height=400&seq=woodmold-gallery-003&orientation=landscape"
    },
    {
      title: "대형 목형",
      description: "대형 제품 생산을 위한 목형",
      image: "https://readdy.ai/api/search-image?query=large%20scale%20wooden%20mold%20pattern%20for%20industrial%20production%20showing%20robust%20construction%20and%20precise%20engineering%20on%20clean%20white%20background%20professional%20manufacturing&width=600&height=400&seq=woodmold-gallery-004&orientation=landscape"
    },
    {
      title: "정밀 소형 목형",
      description: "세밀한 작업이 필요한 소형 목형",
      image: "https://readdy.ai/api/search-image?query=small%20precision%20wooden%20mold%20pattern%20with%20fine%20details%20and%20accurate%20measurements%20for%20delicate%20manufacturing%20work%20on%20clean%20white%20background%20professional%20craftsmanship&width=600&height=400&seq=woodmold-gallery-005&orientation=landscape"
    },
    {
      title: "복합 구조 목형",
      description: "복잡한 형상의 다층 구조 목형",
      image: "https://readdy.ai/api/search-image?query=complex%20multi-layer%20wooden%20mold%20pattern%20with%20intricate%20structure%20and%20precise%20assembly%20for%20advanced%20manufacturing%20on%20clean%20white%20background%20professional%20engineering&width=600&height=400&seq=woodmold-gallery-006&orientation=landscape"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#1e3a8a] mb-6">제작 사례</h2>
          <div className="w-24 h-1 bg-[#D4AF37] mx-auto mb-8"></div>
          <p className="text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto">
            다양한 산업 분야에서 사용되는<br />
            재기목형의 정밀 제작 사례를 확인하세요
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product, index) => (
            <div
              key={index}
              className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-2xl transition-all border border-gray-100"
            >
              <div className="relative w-full h-64 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-[#1e3a8a] mb-2 group-hover:text-[#D4AF37] transition-colors">
                  {product.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">{product.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="/portfolio"
            className="inline-flex items-center justify-center gap-2 bg-[#1e3a8a] hover:bg-[#2563eb] text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-gallery-line text-xl"></i>
            전체 포트폴리오 보기
          </a>
        </div>
      </div>
    </section>
  );
}
